<script lang="tsx">
import type { UnwrapNestedRefs } from "vue";
import isArray from "lodash-es/isArray";
import isEqual from "lodash-es/isEqual";
import findIndex from "lodash-es/findIndex";
import sortBy from "lodash-es/sortBy";
import cloneDeep from "lodash-es/cloneDeep";
import $ from "jquery";
import { ElTable, ElTableColumn, ElPagination, ElPopover, ElMessage, ElMessageBox, ElTableV2 } from "element-plus";
import "./style.scss";
import loadDataMixFunc, { loadDataProps } from "../../commonMix/loadData";
import HeaderMenu from "./HeaderMenu.vue";
import FastTable from "./FastTable/FastTable.vue";
import { defineComponent, reactive, computed, nextTick, watch, h, onMounted, toRefs, onUpdated, onBeforeMount, onBeforeUnmount, onActivated, onDeactivated, ref } from "vue";
import type { PropType, ExtractPropTypes, ComputedRef, VNode, Slot, UnwrapRef, ComponentPublicInstance, Ref, CSSProperties } from "vue";
import type { LoadDataOperateType, LoadDataStateType, FetchApiInterface } from "../../commonMix/loadData/types";
import { TableColumnUnRequird } from "./types";
import type { DataTableType, DataTableColumnType, ElTableType, ElTablePropsType, HeaderMenuType, DataTableCompoundDataType } from "./types";
import { List, debounce, deburr, startCase, throttle } from "lodash-es";
import { buildProps, componentsPropsFilter } from "../../utils/props";
import { copyText } from "@user-center/utils/index";
import DragList from "./DragList.vue";
import { division, addition, subtraction } from "@user-center/utils/common";
import moment from "moment";
import { props } from "quick-vue-components/index";
export const DataTableProps = {
  ...loadDataProps,
  ...buildProps({
    // 是否启用内部排序
    automaticSorting: {
      type: Boolean,
      default: false,
    },
    isFastTable: {
      type: Boolean,
      default: true,
    },
    fullTopHeight: {
      type: Number,
      default: 0,
    },
    /**
     * 存储表头的key
     */
    storageListKey: {
      type: String,
      default: "",
    },
    /**
     * 获取存储表头的请求,promise fetch对象
     */
    getStorageListFetchApi: {
      type: [Boolean, Function as PropType<FetchApiInterface>],
      default: false,
    },
    /**
     * 设置存储表头的请求,promise fetch对象
     */
    setStorageListFetchApi: {
      type: [Boolean, Function as PropType<FetchApiInterface>],
      default: false,
    },
    /**
     * 设置内部table的属性
     */
    tableAttrs: {
      type: Object as PropType<Partial<ElTableType>>,
      default: () => ({}),
    },
    searchToClearSelected: {
      // 搜索清除选中
      type: Boolean,
      default: true,
    },
    /**
     * table的头部渲染，跟element table参数对应
     */
    tableHeader: {
      type: Array as PropType<Array<DataTableColumnType>>,
      default: () => [],
    },

    /**
     * 是否保留选择
     */
    reserveSelection: {
      type: Boolean,
      default: false,
    },
    /**
     * 是否延迟加载
     */
    virtualLazyLoad: {
      type: Boolean,
      default: false,
    },

    /**
     * 是否展示列表下标
     */
    showIdxCol: {
      type: Boolean,
      default: false,
    },

    scrollToLoadMoreData: {
      type: Boolean,
      default: false,
    },

    ctrlData: {
      type: Boolean,
      default: false,
    },
    /**
     * 是否列表有选择框
     */
    selectRow: {
      type: Boolean,
      default: false,
    },
    /**
     * 是否列表选择框只能单选
     */
    singleChoice: {
      type: Boolean,
      default: false,
    },
    /**
     * 列表选中行
     */
    selections: {
      type: Array as PropType<Array<any>>,
      default: () => [],
    },
    /**
     * 是否默认列表高度铺满屏幕
     */
    fullPageList: {
      type: Boolean,
      default: false,
    },
    /**
     * 是否表格范围拖选
     */
    rangeDrag: {
      type: Boolean,
      default: false,
    },
    useVirtual: {
      // 是否虚拟滚动
      type: Boolean,
      default: false,
    },
    lazyloadList: {
      // 是否异步加载列表
      type: Boolean,
      default: false,
    },
    propDataToSetListData: {
       
      type: Boolean,
      default: false,
    },
    lazyloadListLength: {
      type: Number,
      default: 50,
    },
    lazyloadListTime: {
      type: Number,
      default: 1000,
    },
    useVirtualIndexes: {
      // 虚拟滚动索引
      type: Boolean,
      default: true,
    },
    cloneShowData: {
      type: Boolean, // 是否深拷贝滚动数据
      default: false,
    },
    isWindowScroll:{
      type: Boolean,
      default: false,
    },
    virtualShowLength: {
      //  虚拟滚动现实数量
      type: Number,
      default: 40,
    },
    // virtualRangeLength: {
    //   //  虚拟滚动现实数量
    //   type: Number,
    //   default: 5,
    // },
    virtualShowLengthAtuo: {
      //  虚拟滚动现实数量 自适应
      type: Boolean,
      default: false,
    },
    rowHeight: {
      //  虚拟滚动行高
      type: Number,
      default: 30,
    },
    trPrependHeight: {  
        //  tr插槽高度
      type: Number,
      default: 0,
    },
    showVirtualIndex: {
      //  是否显示 虚拟 滚动索引
      type: Boolean,
      default: false,
    },
    // 是否显示 虚拟 滚动选择框
    useVirtualSelect: {
      type: Boolean,
      default: true,
    },
    // 虚拟滚动复制的起始位
    useVirtualCopyIndexes: {
      type: Number,
      default: 2,
    },
    // 设置表格的 id 用于区分表格样式计算
    usevUniquelyId: {
      type: [String, Number],
      default: () => `${Date.now()}`,
    },
  }),
};
export type DataTablePropsType = ExtractPropTypes<typeof DataTableProps>;
export default defineComponent({
  name: "DataTable",
  components: {
    ElTable,
    ElTableColumn,
    ElPagination,
    ElPopover,
    HeaderMenu,
    DragList,
    FastTable,
  },

  props: DataTableProps,

  setup(props: DataTablePropsType, ctx: any): DataTableType {
    // 表格主数据源
    let TabularMianDataSource: any[] = reactive([]);
    // 虚拟列表的裁剪数据
    let orgData: any[] = reactive([]);
    let allFunc: LoadDataOperateType = loadDataMixFunc(props, ctx, {
      /**
       * 列表调用成功后的回调
       * @param {Object} 返回的值 //
       */
      afterSuccessFunc: (res: any) => {
        changeSelectRow(
          props.searchToClearSelected ? [] : compoundData.mutipleSelection,
          true
        );

        nextTick(() => {
          setListFullPageHeight();
        });
      },
      filterSetData: (data: any): any => {
        TabularMianDataSource = data || [];
        if (props.useVirtual && !props.isFastTable) {
          orgData = [...data];
          lastMaxEndIndx = 10;
          if (props.useVirtual && !props.reserveSelection) {
            compoundData.virtualSelect = {};
            nextTick(() => {
              $(`.tableid_${props.usevUniquelyId}`)
                .find("#top-checked")
                .removeClass("is-checked");
              $(`.tableid_${props.usevUniquelyId}`)
                .find("#top-checked>span")
                .removeClass("is-checked");
            });
            ctx.emit("all-select", []);
            selectionChange([]);
          }
          nextTick(() => {
            pagerResize = true;
            useVirtualLengthAuto();
          });
          compoundData.showStartIdx = 0;
          nextTick(() => {
            setTopBottomHeight();
            setScrollLeftFixed(null, true);
            $(`.tableid_${props.usevUniquelyId}`).scrollTop(0);
          });
          return filterVirtualData();
        } else if (props.lazyloadList) {
          orgData = [...data];
          setTimeout(() => {
            scrollDom = getScrollDom();
            if (scrollDom && scrollDom[0]) {
              scrollDom.scrollTop(0);
            }
          }, 200);
          setTimeout(() => {
            startToLazyLoad();
          }, props.lazyloadListTime);
          return data.slice(0, props.lazyloadListLength - 1);
        } else {
          orgData = [...data];
          return data;
        }
      },
      /**
       * 列表调用失败后的回调
       * @param {Error} 返回的错误信息 //
       */
      afterErrorFunc: (err: any) => {
        ElMessage({
          message: err.message ? err.message + "" : err + "",
          type: "error",
        });
        nextTick(() => {
          setListFullPageHeight();
        });
      },
    });
    let virtualShowLength = 0; // 虚拟滚动数量
    let lazyTimer: any = null;
    function startToLazyLoad() {
      if (orgData.length > allFunc.loadDataState.listData.length) {
        let sliceEndIdx =
          allFunc.loadDataState.listData.length + props.lazyloadListLength - 1;
        if (
          orgData.length <
          allFunc.loadDataState.listData.length + props.lazyloadListLength
        ) {
          sliceEndIdx = orgData.length - 1;
        }
        let mergeData: any = orgData.slice(
          allFunc.loadDataState.listData.length - 1,
          sliceEndIdx
        );
        allFunc.loadDataState.listData =
          allFunc.loadDataState.listData.concat(mergeData);

        lazyTimer = setTimeout(() => {
          startToLazyLoad();
        }, props.lazyloadListTime);
      } else {
        clearTimeout(lazyTimer);
      }
    }

    // async function getStorageListString(): string {
    //   let res = "";
    //   return res;
    // }
    async function initTableHeaderStateFunc() {
      let setInitShowHeadersState: any = [];
      let setInitTableHeadersState: DataTableColumnType[] = cloneDeep(
        props.tableHeader || []
      );
      if (props.storageListKey) {
        let storageShowHeadersState: any;
        if (typeof props.getStorageListFetchApi == "function") {
          let getStorageListFetchApi: FetchApiInterface =
            props.getStorageListFetchApi as FetchApiInterface;
          let { id, configData } = await getStorageListFetchApi(
            {
              storageListKey: props.storageListKey,
            },
            {}
          );

          storageShowHeadersState = configData;
          compoundData.storageId = id;
        } else {
          storageShowHeadersState = window.localStorage.getItem(
            "storageListKey_showHeadersState_" + props.storageListKey
          );
        }

        if (storageShowHeadersState) {
          try {
            // 重新改过了记录全部的表头信息
            setInitShowHeadersState = JSON.parse(storageShowHeadersState);
            if (
              setInitShowHeadersState &&
              setInitShowHeadersState.tableHeadersConfig
            ) {
              setTableHeadersConfigs(
                setInitTableHeadersState,
                setInitShowHeadersState.tableHeadersConfig
              ); //设置表头的配置选项
              let setSortInitTableHeadersState: DataTableColumnType[] = sortBy(
                compoundData.tableHeadersConfigs,
                (
                  tableCol: DataTableColumnType,
                  tableColIdx: number
                ): number => {
                  return tableCol.sortColumnIndex;
                }
              );
              setInitTableHeadersState = setSortInitTableHeadersState.filter(
                (o: any) => !o.isHiddenColumn
              );

              setInitShowHeadersState = initShowHeadersState(
                setInitTableHeadersState
              );
              setInitTableHeadersState.map((o: any) => {
                if (o.setColumnWidth && o.setColumnWidth > 0) {
                  o.width = o.setColumnWidth;
                }
              });
            } else {
              setInitShowHeadersState = initShowHeadersState(props.tableHeader);
              setTableHeadersConfigs(props.tableHeader);
            }
          } catch (e) {
            setInitShowHeadersState = initShowHeadersState(props.tableHeader);
            setTableHeadersConfigs(props.tableHeader);
          }
        } else {
          setInitShowHeadersState = initShowHeadersState(props.tableHeader);
          setTableHeadersConfigs(props.tableHeader);
        }
      } else {
        setInitShowHeadersState = initShowHeadersState(props.tableHeader);
        setTableHeadersConfigs(props.tableHeader);
      }
      compoundData.showHeadersState = setInitShowHeadersState;
      compoundData.tableHeaderState = setInitTableHeadersState;
    }

    let compoundData: UnwrapNestedRefs<DataTableCompoundDataType> = reactive({
      rowHeight: props.rowHeight,
      mutipleSelection: cloneDeep(props.selections || []),
      storageId: "",
      tableHeadersConfigs: [],
      showHeadersState: [],
      tableHeaderState: [],
      tableRenderKey: 1,
      listHeight: 300,
      virtualSelect: {},
      showStartIdx: 0,
    });
    let showHeaders: ComputedRef<Array<DataTableColumnType>> = computed(() => {
      let tableHeaders = steFilterHeaders();
      return tableHeaders;
    });

    function setTableHeadersConfigs(
      tableHeaders: DataTableColumnType[],
      tableHeadersConfig: any = {} //本地或服务器存储的表头配置
    ) {
      // 设置表头配置数据
      let resetInitTableHeadersState: DataTableColumnType[] = []; // 重新结合保存的数据生成的新表头
      tableHeaders.map((o: DataTableColumnType, colIdx: number) => {
        let findColumnConf = tableHeadersConfig[o.prop] || {};
        resetInitTableHeadersState.push({
          ...o,
          setColumnWidth:
            findColumnConf.setColumnWidth && findColumnConf.setColumnWidth > 0
              ? findColumnConf.setColumnWidth
              : -1,
          sortColumnIndex:
            typeof findColumnConf.sortColumnIndex == "number"
              ? findColumnConf.sortColumnIndex
              : colIdx,
          isHiddenColumn: !!findColumnConf.isHiddenColumn,
        });
      });

      compoundData.tableHeadersConfigs = resetInitTableHeadersState; //设置表头的配置选项
    //  compoundData.tableRenderKey=(new Date()).valueOf()
    }
    function steFilterHeaders() {
      let tableHeaders = filterHeaders(
        compoundData.tableHeaderState as any,
        (o: DataTableColumnType) => {
          return {
            ...o,
            hidden:
              !o.notSort &&
              findIndex(compoundData.showHeadersState, (obj) => obj == o.prop) <
                0,
          };
        }
      );
      return tableHeaders;
    }
    let refs: any = {};
    const setRef = function (ref: any, key: string): void {
      refs[key] = ref;
    };
    // 组件失活
    let deactivated = false;
    // 保存的虚拟滚动DOM盒子
    let scrollElDom: any;
    let pagerResize = false;
    // 是否已初始化过绑定过事件
    let ifInactivation = ref(0);

    onBeforeMount(() => {
      initTableHeaderStateFunc();
    });
    onMounted(() => {
      if (props.fullPageList) {
        setListFullPageHeight();
        window.addEventListener("resize", debounceSetListHeight);
      }
      if (props.rangeDrag && !props.isFastTable) {
        window.addEventListener("keydown", keydownFn, false);
        window.addEventListener("keyup", keyupFn, false);
      }
      if (props.useVirtual && !props.isFastTable) {
        pagerResize = true;
        initUseVirtualCheckTable();
      }
      if (compoundData.mutipleSelection.length) {
        changeSelectRow(compoundData.mutipleSelection, true);
      }
    });
    onActivated(() => {
      deactivated = false;
      if (!ifInactivation.value) {
        console.log("激活", ifInactivation.value);
        ifInactivation.value = 1;
        if (props.fullPageList) {
          setListFullPageHeight();
          window.addEventListener("resize", debounceSetListHeight);
        }
        if (props.rangeDrag && !props.isFastTable) {
          window.addEventListener("keydown", keydownFn, false);
          window.addEventListener("keyup", keyupFn, false);
        }
        if (props.useVirtual && !props.isFastTable) {
          initUseVirtualCheckTable(true);
          pagerResize = true;
        }
        if (props.lazyloadList) {
          scrollDom = getScrollDom();
          if (scrollDom && scrollDom[0]) {
            scrollDom.scrollTop(0);
          }
          startToLazyLoad();
        }
      }
    });
    onDeactivated(() => {
      deactivated = true;
      if (props.lazyloadList) {
        allFunc.loadDataState.listData = orgData.slice(
          0,
          props.lazyloadListLength - 1
        );
      }
      cancellationEvent();
    });
    onUpdated(() => {
      useVirtualLengthAuto();
    });
    onBeforeUnmount(() => {
      cancellationEvent();
    });
    /**
     * 监听自定义表头更改，需要重新绑定DOM滚动事件，因为上次绑定的DOM将会被销毁
     * */
    watch(
      () => compoundData.tableHeaderState,
      (newValue, oldValue) => {
        if (newValue !== oldValue && oldValue && oldValue.length) {
          setTimeout(() => {
            if (props.useVirtual && !props.isFastTable) {
              initUseVirtualCheckTable(true);
            }
          }, 200);
        }
      },
      { deep: true }
    );
    watch(
      () => props.data,
      (value) => {
        if (value && value.length && props.useVirtual) {
          orgData = [...value];
          $(`.tableid_${props.usevUniquelyId}`).scrollTop(10);
          setScrollLeftFixed(null, true);
          scrollFunc(true);
        }
       
      }
    );
    watch(
      () => compoundData.mutipleSelection,
      (newVal) => {
        ctx.emit("update:selections", newVal);
      }
    );
    watch(
      () => props.selections,
      (newVal) => {
        if (newVal != compoundData.mutipleSelection) {
          changeSelectRow(newVal);
        }
      }
    );
    watch(
      () => props.tableHeader,
      (newVal, oldVal) => {
        if (!isEqual(newVal, oldVal)) {
          compoundData.tableHeaderState = cloneDeep(newVal);
          compoundData.showHeadersState = initShowHeadersState();
          nextTick(() => {
            refs.table &&refs.table.doLayout && refs.table.doLayout();
          });
        }
      }
    );
    watch(
      () => props.virtualShowLength,
      (newVal) => {
        virtualShowLength = newVal;
      },
      { immediate: true, deep: true }
    );
    /// 组件销整体事件的移除
    function cancellationEvent() {
      ifInactivation.value = 0;
      console.log("失活>", ifInactivation.value);
      if (scrollElDom) {
        // 如若存在滚动DOM盒子
        scrollElDom.off("scroll");
      }
      // 缩放事件
      window.removeEventListener("resize", debounceSetListHeight);
      // 按键监听
      window.removeEventListener("keydown", keydownFn);
      window.removeEventListener("keyup", keyupFn);
      // 页面销毁事件
      window.removeEventListener("beforeunload", cancellationEvent);
      scrollElDom = null;
    }
    // 计算虚拟列表自长度适应
    let useVirtualLengthAuto = throttle((mxaLenth = orgData.length) => {
      // 虚拟列表监听缩放
      if (pagerResize && props.useVirtual && !props.isFastTable) {
        pagerResize = false;
        let boxDom: any = $(refs.elTableRef.$el);
        // $(`.tableid_${props.usevUniquelyId}`);
        if (props.virtualShowLengthAtuo && boxDom[0]) {
          let length = (boxDom[0].clientHeight / props.rowHeight).toFixed(0);
          virtualShowLength = Number(length) + 10;
          if (mxaLenth !== 0 && virtualShowLength > mxaLenth) {
            virtualShowLength = mxaLenth;
          }
        }
        let scrollDom: any = $(refs.elTableRef.$el).find("el-scrollbar__wrap");
        boxDom = null;
        scrollDom.scrollTop(10);
        nextTick(() => {
          scrollFunc(true);
          setScrollLeftFixed(null, true);
        });
        scrollDom = null;
      }
    }, 1200);
    const debounceSetListHeight = debounce(setListFullPageHeight, 500);
    // 保存的上次横向滚动的距离
    let lastScrollLeft = 0;
    let scrollDom: any; // 主滚动 盒子
    // 获取滚动盒子
    function getScrollDom(): any {
      if (props.isFastTable) {
        return $(`.tableid_${props.usevUniquelyId} .fast-table__wrap`);
      }
      return $(
        `.tableid_${props.usevUniquelyId}>div>div>.el-table__body-wrapper>.el-scrollbar>.el-scrollbar__wrap`
      );
    }
    function initUseVirtualCheckTable(reset = false): void {
      nextTick(() => {
        scrollDom = getScrollDom();
        scrollElDom = scrollDom;
        if (!scrollDom || !scrollDom[0]) {
          return;
        }
        scrollDom.scrollTop(0);
        scrollDom.off("scroll");
        scrollDom.scroll(scrollFunc); // 设定表格内容区域大盒子的滚动事件
        if (reset) {
          scrollFunc(true);
        }
        if (
          $(`#bottomBlock${props.usevUniquelyId}`).get(0) &&
          $(`#topBlock${props.usevUniquelyId}`).get(0)
        ) {
          setTopBottomHeight();
        }
        scrollDom = null;
        setScrollLeftFixed(null, true); // 初次加载重新计算固定列位置
      });
    }
    function scrollFunc(refresh?: any): void {
      // console.log("scrollFunc", scrollFunc);
      if (!scrollDom) {
        scrollDom = getScrollDom();
      }
      if (typeof lastScrollLeft === "undefined") {
        // 初次执行将偏移设置为零
        lastScrollLeft = 0;
      }
      let scrollTop = scrollDom.scrollTop() || 0;

      //  console.log(scrollDom.height);
      let willScrollRowNumber = parseInt(scrollTop / props.rowHeight + ""); // 计算目前是第几个行编号
      if (willScrollRowNumber < 0) {
        willScrollRowNumber = 0;
      }
      let wilShowStartIdx = willScrollRowNumber;
      if (
        !(compoundData.showStartIdx === wilShowStartIdx && refresh !== true)
      ) {
        compoundData.showStartIdx = wilShowStartIdx;

        if (!$(`#scrollBlock${props.usevUniquelyId}`).get(0)) {
          scrollDom
            .find(".el-table__body tbody")
            .attr("id", `org_tbody_${props.usevUniquelyId}`);
          scrollDom
            .find(".el-table__body tbody")
            .parent()
            .append(`<tbody id="scrollBlock${props.usevUniquelyId}"/>`);
        }

        setTopBottomHeight();
        allFunc.loadDataState.listData = filterVirtualData();
      }
      setScrollLeftFixed(null, false);
    }
    let lastMaxEndIndx = 0;
    // 截取显示设计好的虚拟滚动行数量的数据
    function filterVirtualData(): any[] {
      let startIdx = compoundData.showStartIdx || 0;
      let setEndIdx = virtualShowLength + startIdx;
      console.log("startIdx", startIdx);
      console.log("setEndIdx", setEndIdx);
      console.log("virtualShowLength", virtualShowLength);
      let setData = [];

      setData =
        orgData && orgData[0]
          ? orgData.slice(0 + startIdx, setEndIdx)
          : props.data && props.data[0]
          ? props.data.slice(0 + startIdx, setEndIdx)
          : [];

      return props.cloneShowData ? cloneDeep(setData) : setData;
    }
    // 计算固定列
    function setScrollLeftFixed(setScrollDom?: any, reChange?: boolean): void {
      let maxListBox: any =
        setScrollDom || $(`.tableid_${props.usevUniquelyId}`); // 获取列表内容区大盒子
      if (!scrollDom) {
        scrollDom = getScrollDom();
      }
      if (reChange || scrollDom.scrollLeft() !== lastScrollLeft) {
        // 与保存的上次偏移量做比较，判断是否发生了右滚动动，而重新计算固定列的位偏移量
        maxListBox
          .find(
            ".use-virtual-select,.use-virtual-options,.use-virtual-indexes,.use-virtual-right-addition1,.use-virtual-right-addition2"
          )
          .css("opacity", "0"); // 为防止不同步的错位显示 先隐藏元素
        debounce(() => {
          let scrollLeft = scrollDom.scrollLeft();
          let contentWeight = scrollDom.width();
          let tbodyWeight = scrollDom.find("tbody").width();
          let offset: number = contentWeight + scrollLeft - tbodyWeight;
          maxListBox
            .find(".use-virtual-select")
            .css("transform", "translateX(" + scrollLeft + "px)"); // 固定选择列的偏移量计算
          maxListBox
            .find(".use-virtual-indexes")
            .css("transform", "translateX(" + scrollLeft + "px)");
          let addition2 = maxListBox.find(".use-virtual-right-addition2");
          if (addition2[0]) {
            addition2.css("transform", "translateX(" + offset + "px)");
          }
          let addition1 = maxListBox.find(".use-virtual-right-addition1");
          if (addition1[0]) {
            addition1.css("transform", "translateX(" + offset + "px)");
          }
          // 固定选择自定义列的偏移量计算
          maxListBox
            .find(".use-virtual-options")
            .css("transform", "translateX(" + offset + "px)");
          lastScrollLeft = scrollLeft; // 保存向右滚动距离？
          setScrollDom = null;
          maxListBox
            .find(
              ".use-virtual-select,.use-virtual-options,.use-virtual-indexes,.use-virtual-right-addition1,.use-virtual-right-addition2"
            )
            .css("opacity", "1"); // 重新显示排列好的元素
          maxListBox = null;
        }, 80)();
      } else {
        maxListBox = null;
        setScrollDom = null;
      }
    }
    function setTopBottomHeight(): void {
      if ($(`#org_tbody_${props.usevUniquelyId}`).get(0)) {
        let renderTrLength = $(`#org_tbody_${props.usevUniquelyId}`).find(
          "tr"
        ).length;
        if (
          props.rowHeight * orgData.length !=
          $(`#scrollBlock${props.usevUniquelyId}`).height()
        ) {
          $(`#scrollBlock${props.usevUniquelyId}`)
            .css(
              "height",
              props.rowHeight * (orgData.length - renderTrLength) + "px"
            )
            .css("min-width", "100px");
        }
        let translateY = props.rowHeight * compoundData.showStartIdx;

        $(`#org_tbody_${props.usevUniquelyId}`).css(
          "transform",
          `translateY(${translateY}px)`
        );
      }

      // $(`#bottomBlock${props.usevUniquelyId}`).css(
      //   "height",
      //   props.rowHeight *
      //     (orgData.length - compoundData.showStartIdx - virtualShowLength) +
      //     "px"
      // );
    }
    let selectNumber = 0;
    let allSelectFlag = false; // 全选
    function isRowSelect(row: any): boolean {
      return !!compoundData.virtualSelect[row.id];
    }
    // 全选切换
    function toggleAllSelect(): void {
      let setData = {};
      if (!isRowSelectAll()) {
        orgData.map((o) => {
          if (setData[o.id]) {
            //
          }
          setData[o.id] = o;
        });
      }
      compoundData.virtualSelect = setData;
      setHeaderDom();
      let setList: any = Object.keys(compoundData.virtualSelect).map(
        (k) => compoundData.virtualSelect[k]
      );
      ctx.emit("all-select", setList);
      selectionChange(setList);
    }
    // 表格选中变化
    function selectionChange(selection: any[], i?: number): void {
      selectNumber = selection.length;
      ctx.emit("select", selection, allSelectFlag);
      compoundData.mutipleSelection = selection;
      ctx.emit("update:selections", selection);
    }
    // 切换表格表头的 radio 全选与非全选显示状态
    function setHeaderDom(): void {
      let tableBox: any = $(`.tableid_${props.usevUniquelyId}`);
      let res = isRowSelectAll();
      if (!res) {
        tableBox.find("#top-checked").removeClass("is-checked");
        tableBox.find("#top-checked>span").removeClass("is-checked");
      } else if (res) {
        tableBox.find("#top-checked").addClass("is-checked");
        tableBox.find("#top-checked>span").addClass("is-checked");
      }
      tableBox = null;
    }
    // 判断 是否全选
    function isRowSelectAll(): boolean {
      let selectLength = Object.keys(compoundData.virtualSelect).length;

      let res = !!(selectLength && selectLength === orgData.length);

      return res;
    }
    // 表格选择切换
    function toggleSelect(row: any): void {
      // 虚拟表格的select 选中
      if (compoundData.virtualSelect[row.id]) {
        // 以行id 作为选中的标识
        delete compoundData.virtualSelect[row.id];
      } else {
        if (props.singleChoice) {
          // 是否单选
          compoundData.virtualSelect = { [row.id]: row };
        } else {
          compoundData.virtualSelect[row.id] = row;
        }
        compoundData.virtualSelect[row.id] = row;
      }

      setHeaderDom();
      let setList = Object.keys(compoundData.virtualSelect).map(
        (k) => compoundData.virtualSelect[k]
      );
      if (props.singleChoice) {
        ctx.emit("singleSelect", row, setList, !!setList.length);
      }
      ctx.emit("user-select", setList, row, compoundData.virtualSelect[row.id]);

      selectionChange(setList);
    }
    /**
     * 设置列表默认占全页面高度
     */
    function setListFullPageHeight(): void {
      if (deactivated) {
        return;
      }
      pagerResize = true;
      if (!props.fullPageList) return;
      let windowHeight: number = ($(window) as any).height();
      let tableTop: number = refs.elTableRef
        ? ($(refs.elTableRef.$el) as any).offset().top
        : 0;
      let pageWrapHeight: number = props.pagination
        ? ($(refs.pageWrap) as any).outerHeight()
        : 0;
      let setHeight: number =
        windowHeight - tableTop - pageWrapHeight - props.fullTopHeight;
      compoundData.listHeight = setHeight;
      nextTick(() => {
        if (refs.elTableRef) {
          if (refs.elTableRef.layout)
            refs.elTableRef.layout.setHeight(setHeight);
          if (refs.elTableRef.doLayout) refs.elTableRef.doLayout();
        } else {
          nextTick(() => {
            if (refs.elTableRef) {
              if (refs.elTableRef.layout)
                refs.elTableRef.layout.setHeight(setHeight);
              if (refs.elTableRef.doLayout) refs.elTableRef.doLayout();
            }
          });
        }
        // 如果是虚拟滚动 重新计算固定列位置
        if (props.useVirtual && !props.isFastTable) {
          setScrollLeftFixed(null, true);
        }
      });
    }

    /**
     * 初始化展示表头的状态
     */
    function initShowHeadersState(
      tableHeaderState?: Array<DataTableColumnType>
    ): Array<string> {
      const setShowHeadersState: string[] = [];
      filterHeaders(
        (tableHeaderState
          ? tableHeaderState
          : compoundData.tableHeaderState) as any,
        (o) => {
          setShowHeadersState.push(o.prop);
          return o;
        }
      );
      return setShowHeadersState;
    }

    /**
     * table的头部配置的过滤函数，用来过滤当选择表头时隐藏的表头
     * @param  {Array} tableHeader tableHeader 的配置
     * @param  {Function}  setFunc 设置每个表头项的方法
     */
    function filterHeaders(
      tableHeader: Array<DataTableColumnType>,
      setFunc = (o: DataTableColumnType): DataTableColumnType => o
    ): Array<DataTableColumnType> {
      const res: DataTableColumnType[] = [];
      tableHeader &&
        tableHeader.map((item) => {
          if (item.children) {
            item.children = filterHeaders(
              item.children as Array<DataTableColumnType>,
              setFunc
            );
          }
          const setItem = setFunc(item);
          if (!setItem.hidden) {
            res.push(setItem);
          }
        });
      return res;
    }

    /**
     * 修改选中行的方法
     * @param  {Object} newVal 新的选中行数据
     * @param  {Boolean} init  是否是在组件初始化
     */
    function changeSelectRow<T>(newVal: Array<T>, init = false) {
      if (refs.elTableRef) {
        refs.elTableRef.clearSelection();

        newVal.map((row: T) => {
          if (init) {
            let tableData =
              refs.elTableRef?.props &&
              (refs.elTableRef?.props?.data as List<T>);

            const rowIdx = findIndex(tableData, row);
            if (rowIdx >= 0) {
              row = tableData[rowIdx];
            }
          }
          refs.elTableRef?.toggleRowSelection(row, true);
        });
      }
      compoundData.mutipleSelection = cloneDeep(newVal);
    }

    /**
     * 选中行后的回调
     * @param {Object} 选中行的数据
     */
    function onSelectChange<T>(val: Array<T>) {
      console.log(val);
      if (props.singleChoice) {
        compoundData.mutipleSelection = val[val.length - 1]
          ? [val[val.length - 1]]
          : [];
        return;
      }
      compoundData.mutipleSelection = val;
      ctx.emit("update:selections", val);
    }
    /**
     * 排序变化后的回调
     * @param {Object} 选中行的数据
     */
    function onSortChange(e: any) {
      if (
        props.tableAttrs &&
        props.tableAttrs.onSortChange &&
        typeof props.tableAttrs.onSortChange === "function"
      ) {
        props.tableAttrs.onSortChange(e);
      }
      // 如果启用了表格组件的内部排序
      if (props.automaticSorting) {
        let target = props.tableHeader.find((item) => item.prop === e.prop);
        if (target) {
          let sortType: string = target.sortType || "string";
          TabularMianDataSource.sort((last: any, next: any) => {
            let { prop, order } = e;
            let result = 0;
            switch (sortType) {
              case "string":
                result = Sort_String(last, next, prop, order);
                break;
              case "number":
                result = Sort_numerical(last, next, prop, order);
                break;
              case "time":
                result = Sort_Time(last, next, prop, order);
                break;
            }
            return result;
          });
          if (props.useVirtual && !props.isFastTable) {
            setOrgData(TabularMianDataSource);
            initUseVirtualCheckTable();
          } else {
            allFunc.loadDataState.listData = cloneDeep(TabularMianDataSource);
          }
        }
      }
    }
    let sort_string_classify: any = {};
    // 处理 字值类型
    function Sort_numerical(
      last: any,
      next: any,
      key: string,
      order = "descending"
    ) {
      let nullValue = 0;
      switch (order) {
        case "descending":
          nullValue = -99999999999999999999;
          break;
        default:
          nullValue = 99999999999999999999;
          break;
      }
      let notType = ["", null, undefined];
      let lastValue: any = !notType.includes(last[key])
        ? Number(last[key])
        : nullValue;
      let nextValue: any = !notType.includes(next[key])
        ? Number(next[key])
        : nullValue;
      if (order === "descending") {
        return subtraction(nextValue, lastValue);
      } else {
        return subtraction(lastValue, nextValue);
      }
    }
    // 处理 字符类型
    function Sort_String(
      last: any,
      next: any,
      key: string,
      order = "descending"
    ) {
      let nullValue = 0;
      switch (order) {
        case "descending":
          nullValue = -99999999999999999999;
          break;
        default:
          nullValue = 99999999999999999999;
          break;
      }
      let lastValue: any = 0;
      let nextValue: any = 0;
      if (last[key]) {
        let lastLength = last[key].length;
        let lastClassify: any = 0;
        if (!sort_string_classify[`_${lastLength}`]) {
          sort_string_classify[`_${lastLength}`] = [];
        }
        if (!sort_string_classify[`_${lastLength}`].includes(last[key])) {
          sort_string_classify[`_${lastLength}`].push(last[key]);
          lastClassify = sort_string_classify[`_${lastLength}`].length - 1;
        } else {
          lastClassify = sort_string_classify[`_${lastLength}`].indexOf(
            last[key]
          );
        }
        lastValue = addition(
          lastLength,
          division(lastClassify == -1 ? 0 : lastClassify + 1, 1000)
        );
      } else {
        lastValue = nullValue;
      }
      if (next[key]) {
        let nextLength = next[key].length;
        let nextClassify: any = 0;
        if (!sort_string_classify[`_${nextLength}`]) {
          sort_string_classify[`_${nextLength}`] = [];
        }
        if (!sort_string_classify[`_${nextLength}`].includes(next[key])) {
          sort_string_classify[`_${nextLength}`].push(next[key]);
          nextClassify = sort_string_classify[`_${nextLength}`].length - 1;
        } else {
          nextClassify = sort_string_classify[`_${nextLength}`].indexOf(
            next[key]
          );
        }
        nextValue = addition(
          nextLength,
          division(nextClassify == -1 ? 0 : nextClassify + 1, 1000)
        );
      } else {
        nextValue = nullValue;
      }
      if (order === "descending") {
        return subtraction(nextValue, lastValue);
      } else {
        return subtraction(lastValue, nextValue);
      }
    }
    // 处理 时间类型
    function Sort_Time(
      last: any,
      next: any,
      key: string,
      order = "descending"
    ) {
      let nullValue = 0;
      switch (order) {
        case "descending":
          nullValue = -99999999999999999999;
          break;
        default:
          nullValue = 99999999999999999999;
          break;
      }
      let notType = ["", null, undefined];
      let lastValue: any = !notType.includes(last[key])
        ? moment(last[key]).valueOf()
        : nullValue;
      let nextValue: any = !notType.includes(next[key])
        ? moment(next[key]).valueOf()
        : nullValue;
      if (order === "descending") {
        return subtraction(nextValue, lastValue);
      } else {
        return subtraction(lastValue, nextValue);
      }
    }
    /**
     * table 项的 ScopedSlot 渲染函数
     * @param  {Object} item 列表头的配置
     */
    function headerColScopedSlotsRender(
      item: DataTableColumnType
    ): Slot | undefined {
      const res: Slot | undefined = item.slots && item.slots.default;
      return res;
    }
    /**
     * table 项的 ScopedSlot 渲染函数
     * @param  {Object} item 列表头的配置 @header 表头配置
     */
    function headerColScopedSlotsHeaderRender(
      item: DataTableColumnType
    ): Slot | undefined {
      const res: Slot | undefined = item.slots && item.slots.header;
      return res;
    }
    /**
     * table的头部渲染函数，将数据渲染成table-header-column
     * @param  {Array} tableHeader tableHeader 的配置
     */
    function headerRender(tableHeader: Array<DataTableColumnType>): VNode[] {
      return tableHeader && tableHeader.length && !ctx.slots.default
        ? tableHeader.map((item: DataTableColumnType) => {
            let setSlot = headerColScopedSlotsRender(item);
            let headerSetSlot = headerColScopedSlotsHeaderRender(item);
            return h(
              ElTableColumn,
              {
                ...componentsPropsFilter(item, ElTableColumn),
                prop: item.prop,
                label: item.label,
              },
              {
                default:
                  setSlot ||
                  (item.children && item.children.length
                    ? headerRender(item.children as Array<DataTableColumnType>)
                    : undefined),
                header:
                  headerSetSlot ||
                  (item.children && item.children.length
                    ? headerRender(item.children as Array<DataTableColumnType>)
                    : undefined),
              }
            );
          })
        : ctx.slots.default || null;
    }

    /**
     * 当鼠标右键事件，用来处理自定义表头等等
     * @param  {Event} e 右键事件
     */
    function onContextmenu(e: MouseEvent) {
      if (e.target && $(e.target).parents("thead").length) {
        e.stopPropagation();
        e.preventDefault();

        (refs.headerMenuRef as HeaderMenuType).rightClick(e);
      }
    }
    /**
     * 表格范围拖选实现
     */
    // 单元格 class
    function cellClassNameFn(data: any): string {
      let externalClass = "";
      if (
        props.tableAttrs.cellClassName &&
        typeof props.tableAttrs.cellClassName === "function"
      ) {
        externalClass = props.tableAttrs.cellClassName();
      }
      let rowIndex = data.rowIndex;
      if (props.useVirtual && !props.isFastTable) {
        rowIndex = data.rowIndex + compoundData.showStartIdx;
      }
      return `row${rowIndex}_column${data.columnIndex} ${externalClass}`;
    }
    // 键盘按下
    let keyboardDow = false;
    // 最初位于的元素
    let initialDomClass: any;
    // 移动时当前位于的元素
    let perchDomClass: any;
    // 是否离开表格
    let leaveTable = false;
    function keydownFn(e: any): void {
      if (deactivated) {
        return;
      }
      console.log("e", e);
      if ((e.keyCode === 18 || e.altKey == true) && !leaveTable) {
        keyboardDow = true;
      } else {
        $(".table-scope-checked").removeClass("table-scope-checked");
        keyboardDow = false;
      }
      if (e.altKey == true) {
        if (e.keyCode == 67) {
          processClass("copy");
        }
      }
    }
    function keyupFn(e: any): void {
      if (deactivated) {
        return;
      }
      if (e.keyCode === 18 || e.altKey == true) {
        processClass("cancel");
        keyboardDow = false;
        initialDomClass = "";
        perchDomClass = "";
      }
    }
    // 鼠标按下
    function onMouseDownFn(row: any, column: any, cell: any, event: any): void {
      if (!props.rangeDrag || !keyboardDow) {
        return;
      }
      let targetTd: any;
      let classList: any = [...event.target.classList];
      if (classList.includes("el-table__cell")) {
        targetTd = event.target;
      } else {
        targetTd = event.target.offsetParent;
      }
      if (targetTd && targetTd.className) {
        let classs: any = targetTd.classList ? [...targetTd.classList] : [];
        initialDomClass = classs.find(
          (str: string) =>
            str.indexOf("row") !== -1 && str.indexOf("_column") !== -1
        );
        if (initialDomClass) {
          targetTd.classList.add("table-scope-checked");
        }
      }
    }
    // 鼠标离开组件表格
    function leavePageFn() {
      leaveTable = true;
      keyboardDow = false;
    }
    // 单元格 鼠标移入
    function cellMouseEnterFn(row: any, column: any, cell: any, event: any) {
      leaveTable = false;
      if (keyboardDow) {
        debounce(() => {
          let targetTd: any;
          if (event.target.className.indexOf("cell el-tooltip") !== -1) {
            targetTd = event.target.offsetParent;
          } else {
            targetTd = event.target;
          }
          let classname: any;
          if (targetTd && targetTd.className) {
            let classs: any = targetTd.className.split(" ");
            classname = classs.find(
              (str: string) =>
                str.indexOf("row") !== -1 && str.indexOf("_column") !== -1
            );
            perchDomClass = classname;
            processClass("paint");
          }
          targetTd = null;
          event = null;
        }, 200)();
      }
    }
    // 计算框选数据
    function processClass(incomingState = "paint"): void {
      if (!scrollDom) {
        scrollDom = getScrollDom();
      }

      try {
        if (!initialDomClass || !perchDomClass) {
          return;
        }
        let initialDomData = extractData(initialDomClass);
        let perchDomData = extractData(perchDomClass);
        /**
         * 选框范围
         * @row 行跨度 @column 列跨度
         * @rowAllQty 行 @columnAllQty 列
         * @classList 计算出涵盖单元格的坐标class
         * @dataLocation 列跨度大致范围 大数组index对应行索引 二级数组内存储当前行的所有列索引
         * @positionalData 二维数组[[每个单元格坐标位置]],内部二级数组对应单个元格[当前单元格 行 位置,当前单元格 列 位置]
         * */
        let rowAllQty = initialDomData[0] - perchDomData[0];
        let columnAllQty = initialDomData[1] - perchDomData[1];
        let row = Math.abs(rowAllQty);
        let column = Math.abs(columnAllQty);
        let positionalData = [];
        let classList: any[] = [];
        let dataLocation: any[] = [];
        // 计算选框内容
        for (let index = -1; index < row; index++) {
          let rowQty = rowAllQty < 0 ? index + 1 : -(index + 1);
          dataLocation[initialDomData[0] + rowQty] = [];
          for (let i = -1; i < column; i++) {
            let columnQty = columnAllQty < 0 ? i + 1 : -(i + 1);
            dataLocation[initialDomData[0] + rowQty].push(
              initialDomData[1] + columnQty
            );
            positionalData.push([
              initialDomData[0] + rowQty,
              initialDomData[1] + columnQty,
            ]);
            classList.push(
              `row${initialDomData[0] + rowQty}_column${
                initialDomData[1] + columnQty
              }`
            );
          }
        }
        $(".el-table__row>.hover-row").removeClass("hover-row");
        let classGather = "." + classList.join(",.");
        let elList: any = scrollDom
          .find(classGather)
          .not('[class*="is-hidden"]');
        if (incomingState === "paint") {
          // 如果是是粉刷底色
          $(".table-scope-checked").removeClass("table-scope-checked");
          let list: any = elList.not('[class*="table-scope-checked"]');
          list.addClass("table-scope-checked");
          list = null;
        } else if (incomingState === "copy") {
          // 如果是框选确定准备复制
          let str: any = "";
          str = assembleSelectContent(elList, positionalData, column);
          copy(str, row);
          elList.removeClass("table-scope-checked");
        } else if (incomingState === "cancel") {
          // 如果是退出选中状态
          elList.removeClass("table-scope-checked");
        }
        elList = null;
        // eslint-disable-next-line no-empty
      } catch (err) {}
    }
    function assembleSelectContent(
      elList: any,
      positionalData: any,
      column: any
    ) {
      if (orgData ? !orgData[0] : true) {
        orgData = [...props.data];
      }
      // 字符拼接 @column 判断是否单列
      let str = "";
      let traverseObjs: any = !props.useVirtual ? elList : positionalData;

      if (column) {
        let rowKey: any = positionalData[0][0];
        for (let index = 0; index < traverseObjs.length; index++) {
          const item: any = traverseObjs[index];
          if (item) {
            let Enter: any;
            let state = positionalData[index + 1]
              ? rowKey !== positionalData[index + 1][0]
              : true;
            // 判断是否是下一行数据
            if (state) {
              rowKey = positionalData[index + 1]
                ? positionalData[index + 1][0]
                : true;
              Enter = "\r\n";
            }
            let content = "";
            if (!props.useVirtual) {
              content = item.textContent || "   ";
            } else {
              let tableHeader: any = showHeaders.value;
             
              try {
                content =
                  orgData[positionalData[index][0]][
                    tableHeader[
                      positionalData[index][1] - props.useVirtualCopyIndexes
                    ].prop
                  ] || "   ";
              } catch (e) {
                console.log(e);
              }

              console.log("tableHeader content", content);
            }
            if (str === "") {
              str = Enter ? `${content}${Enter}` : `${content}`;
            } else {
              if (Enter) {
                str = `${str}\t${content}${Enter}`;
              } else {
                if (column) {
                  if (rowKey !== positionalData[index - 1][0]) {
                    str = `${str}${content}`;
                  } else {
                    str = `${str}\t${content}`;
                  }
                }
              }
            }
          }
        }
      } else {
        for (let index = 0; index < traverseObjs.length; index++) {
          const item: any = traverseObjs[index];
          if (item) {
            // 判断是否是下一行数据
            let content = "   ";
            if (!props.useVirtual) {
              content = item.textContent || "   ";
            } else {
              let tableHeader: any = showHeaders.value;
              content =
                orgData[positionalData[index][0]][
                  tableHeader[
                    positionalData[index][1] - props.useVirtualCopyIndexes
                  ].prop
                ] || "   ";
            }
            if (str === "") {
              str = `${content}\r\n`;
            } else {
              str = `${str}${content}\r\n`;
            }
          }
        }
      }
      traverseObjs = null;
      return str;
    }
    function extractData(str: string): number[] {
      let list: number[];
      let strs = str.split("_");
      list = [
        Number(strs[0].split("row")[1]),
        Number(strs[1].split("column")[1]),
      ];
      return list;
    }
    //一键复制
    async function copy(text: string, row: number): Promise<void> {
      try {
        await copyText(text);
        ElMessage({
          type: "success",
          message: `成功复制 ${row + 1} 条数据`,
        });
      } catch (e) {
        ElMessage({
          type: "warning",
          message: `自动复制失败,请手动复制`,
        });
        ElMessageBox.prompt(`共 ${row + 1} 条数据`, "请手动复制", {
          inputType: "textarea",
          inputValue: text,
          customClass: "batch-copy-failure-data",
        });
      }
    }
    function setOrgData(data: any[]) {
      orgData = [...data];
      let scrollDom: any = getScrollDom();
      setScrollLeftFixed(null, true);
      let scrollTop: any = scrollDom.scrollTop() + 20;
      scrollDom.scrollTop(scrollTop);
      scrollDom = null;
      scrollFunc(true);
    }
    // 拖拽保存头部信息
    async function headerDragendFn(
      newWidth: number,
      oldWidth: number,
      column: any,
      event: any
    ) {
      //表头拖动方法
      if (props.storageListKey) {
        let tableHeadersConfig = {};

        let tableHeadersConfigs = sortBy(
          cloneDeep(compoundData.tableHeadersConfigs),
          (o: any, i: number) =>
            typeof o.sortColumnIndex == "number" ? o.sortColumnIndex : i
        );
        tableHeadersConfigs.map((o: any, i: number) => {
          tableHeadersConfig[o.prop] = {
            sortColumnIndex: i,
            setColumnWidth:
              column.prop == o.prop
                ? newWidth
                : o.setColumnWidth > 0
                ? o.setColumnWidth
                : -1,
            isHiddenColumn: compoundData.showHeadersState.indexOf(o.prop) < 0,
          };
        });
        if (props.setStorageListFetchApi) {
          try {
            let res: any = await (
              props.setStorageListFetchApi as FetchApiInterface
            )(
              {
                storageListKey: props.storageListKey,
                storageConfig: JSON.stringify({ tableHeadersConfig }),
                id: compoundData.storageId,
              },
              {}
            );

            if (!compoundData.storageId && res.data) {
              compoundData.storageId = res.data;
            }
          } catch (e) {
            console.log(e);
          }
        } else {
          window.localStorage.setItem(
            "storageListKey_showHeadersState_" + props.storageListKey,
            JSON.stringify({ tableHeadersConfig })
          );
        }
        setTableHeadersConfigs(props.tableHeader, tableHeadersConfig);
      }
    }
    return {
      ...allFunc,
      orgData,
      // mutipleSelection,
      // showHeadersState,
      setTableHeadersConfigs,
      setHeaderDom,
      initUseVirtualCheckTable,
      toggleAllSelect,
      toggleSelect,
      isRowSelect,
      cellMouseEnterFn,
      cellClassNameFn,
      compoundData: compoundData as any,
      showHeaders,
      refs,
      setRef,
      setOrgData,
      tableHeader: compoundData.tableHeaderState as any,
      onSortChange,
      onContextmenu,
      onMouseDownFn,
      onSelectChange,
      headerRender,
      headerColScopedSlotsRender,
      setListFullPageHeight,
      changeSelectRow,
      leavePageFn,
      headerDragendFn,
    };
  },
  render(
    _ctx: ComponentPublicInstance<DataTablePropsType, DataTableType>
  ): VNode {
    const {
      loadDataState,
      tableAttrs,
      pageProps,
      handleCurrentChange,
      handleSizeChange,
      pagination,
      showIdxCol,
      selectRow,

      setRef,
    } = _ctx;
    let { rowHeight, scrollToLoadMoreData } = _ctx.$props;
    const pageOn = {
      "onUpdate:current-page": (data: any) => {
        if (_ctx.$props.useVirtual) {
          _ctx.compoundData.virtualSelect = [];
          _ctx.$emit("all-select", []);
        }
        handleCurrentChange(data);
      },
      "onUpdate:page-size": (data: any) => {
        if (_ctx.$props.useVirtual) {
          _ctx.compoundData.virtualSelect = [];
          _ctx.$emit("all-select", []);
        }
        handleSizeChange(data);
      },
    };
    const setPageProps = {
      total: loadDataState.total,
      layout: "total,sizes,prev,pager,next,jumper",
      pageSizes: [20, 50, 100, 200, 500, 1000, 5000],
      background: true,
      ...pageProps,
      "current-page": loadDataState.currentPage,
      pageSize: pagination ? loadDataState.pageSize : 1000000000,
    };
    // 设置显示序号
    const idxScopedSlots = (scope: any) => {
      // console.log(loadDataState.listData.length);
      return (
        <span>
          {scope.$index +
            ((pagination ? loadDataState.pageSize : 0) *
              (loadDataState.currentPage - 1) +
              1)}
        </span>
      );
    };
    const useVirtualScopedSlots = {
      default: (scope: any) => {
        return (
          <div style="visibility: visible" key={scope.row.id + "-id"}>
            <label
              class={{
                "el-checkbox": true,
                "is-checked": _ctx.isRowSelect(scope.row),
              }}
              onClick={(event) => {
                event.preventDefault();
                _ctx.toggleSelect(scope.row);
              }}
            >
              <span
                class={{
                  "el-checkbox__input": true,
                  "is-checked": _ctx.isRowSelect(scope.row),
                }}
              >
                <span class="el-checkbox__inner"></span>
                <input
                  type="checkbox"
                  aria-hidden="false"
                  value=""
                  class="el-checkbox__original"
                />
              </span>
            </label>
          </div>
        );
      },
      header: () => {
        return (
          <div
            style="visibility: visible"
            onClick={(event) => {
              if (!_ctx.$props.singleChoice) {
                event.preventDefault();
                _ctx.toggleAllSelect();
              }
            }}
          >
            <label id="top-checked" class="el-checkbox">
              <span
                class={
                  _ctx.$props.singleChoice
                    ? "is-disabled el-checkbox__input"
                    : "el-checkbox__input"
                }
              >
                <span class="el-checkbox__inner"></span>
                <input
                  type="checkbox"
                  aria-hidden="false"
                  class="el-checkbox__original"
                  value=""
                />
              </span>
            </label>
          </div>
        );
      },
    };
   
    return (
      <div
       
        class="comp-datatable"
        {...{
          onContextmenu: _ctx.onContextmenu,
        }}
      >
        <DragList
          {...{
            ref: (el: any) => setRef(el, "headerMenuRef"),
            getTableObj: () => _ctx,
          }}
        />

        <div
          onMouseleave={_ctx.leavePageFn}
          key={`tableid_${_ctx.$props.usevUniquelyId}`}
          class={`tableid_${_ctx.$props.usevUniquelyId} ${
            _ctx.$props.useVirtual ? "virtual-table" : ""
          }  ${
            _ctx.$props.useVirtual && rowHeight
              ? "virtual-row-height-" + rowHeight
              : ""
          }`}
        >
          {_ctx.$props.useVirtual && rowHeight ? (
            <style>{`
            .virtual-row-height-${rowHeight} .el-table__body td.el-table__cell,
            .virtual-row-height-${rowHeight} .fast-table__body__tbody td.fast-table__body__td{
              padding:0px;
              height:${rowHeight - 8 <= 0 ? "auto" : rowHeight + "px"};
            }
            .virtual-row-height-${rowHeight} .el-table__body td.el-table__cell.use-virtual-select>div.cell{
              overflow:hidden;
            }
        .virtual-row-height-${rowHeight} .el-table__body td.el-table__cell>div.cell,
        .virtual-row-height-${rowHeight} .fast-table__body__tbody td.fast-table__body__td>div.fast-table__body__td__cont{
          height:${rowHeight - 8 <= 0 ? "auto" : rowHeight + "px"};
          margin:-4px 0px;
          padding:8px 12px;
          line-height:1.2;
          overflow:auto;
          display:flex;
          flex-direction: column;
          justify-content: center;
          align-items: flex-start;

        }
       .el-table__body td.el-table__cell>div.cell::-webkit-scrollbar,
       .virtual-row-height-${rowHeight} .fast-table__body__tbody td.fast-table__body__td>div.fast-table__body__td__cont::-webkit-scrollbar
       {
          width: 2px; /* 滚动条宽度 */
          height: 2px;
        }

        /* 滚动条轨道样式 */
         .el-table__body td.el-table__cell>div.cell::-webkit-scrollbar-track,
         .virtual-row-height-${rowHeight} .fast-table__body__tbody td.fast-table__body__td>div.fast-table__body__td__cont::-webkit-scrollbar-track {
          background-color: rgba(0,0,0,0.1); /* 轨道背景色 */
        }
        
        /* 滚动条滑块样式 */
         .el-table__body td.el-table__cell>div.cell::-webkit-scrollbar-thumb,
         .virtual-row-height-${rowHeight} .fast-table__body__tbody td.fast-table__body__td>div.fast-table__body__td__cont::-webkit-scrollbar-thumb {
          background-color: rgba(0,0,0,0.1);  /* 滑块背景色 */
        }
        
        /* 滚动条滑块在鼠标悬停时的样式 */
         .el-table__body td.el-table__cell>div.cell::-webkit-scrollbar-thumb:hover,
         .virtual-row-height-${rowHeight} .fast-table__body__tbody td.fast-table__body__td>div.fast-table__body__td__cont::-webkit-scrollbar-thumb:hover{
          background-color: rgba(0,0,0,0.2);  /* 悬停时滑块背景色 */
        } 

        `}</style>
          ) : null}

          {_ctx.$props.isFastTable ? (
            <div v-loading={loadDataState.loading}>
              <FastTable
                key={_ctx.compoundData.tableRenderKey}
                ref={(el: any) => setRef(el, "elTableRef")}
                {...{
                  selectRow: selectRow,
                  virtualList: _ctx.$props.useVirtual,
                  showIdx: showIdxCol || _ctx.$props.showVirtualIndex,
                  baseIdx: _ctx.compoundData.showStartIdx || 0,
                  rangDragToCopy: _ctx.$props.rangeDrag,
                  trPrependHeight: _ctx.$props.trPrependHeight,
                  ...tableAttrs,

                  tableHeaders: _ctx.showHeaders,
                  dataToReScrollTop: !_ctx.$props.lazyloadList,
                  cellClassName: _ctx.cellClassNameFn,
                  onSortChange: _ctx.onSortChange,
                  onCellClick: _ctx.onMouseDownFn,
                  onCellMouseEnter: _ctx.cellMouseEnterFn,
                  onSelectionChange: _ctx.onSelectChange,
                  onHeaderDragend: _ctx.headerDragendFn,
                  rowHeight: rowHeight,
                  scrollToLoadMoreData: scrollToLoadMoreData,

                  data:_ctx.$props.propDataToSetListData?_ctx.$props.data:(
                   isArray(loadDataState.listData)
                    ? loadDataState.listData
                    : []),
                  height: tableAttrs.height
                    ? tableAttrs.height
                    : _ctx.$props.fullPageList
                    ? _ctx.compoundData.listHeight
                    : 400,
                }}
              >{{
                headerTopBlock:_ctx.$slots && _ctx.$slots.headerTopBlock? _ctx.$slots.headerTopBlock : undefined,
                tbodyWrap:_ctx.$slots && _ctx.$slots.tbodyWrap? _ctx.$slots.tbodyWrap : undefined,
                trPrepend:_ctx.$slots && _ctx.$slots.trPrepend? _ctx.$slots.trPrepend : undefined,
                tablePrepend:_ctx.$slots && _ctx.$slots.tablePrepend? _ctx.$slots.tablePrepend : undefined,
              }}</FastTable>
            </div>
          ) : (
            <ElTable
              key={"table" + _ctx.compoundData.tableRenderKey}
              {...{
                onCellClick: _ctx.onMouseDownFn,
                onCellMouseEnter: _ctx.cellMouseEnterFn,
                onSelectionChange: _ctx.onSelectChange,
                border: true,
                ...tableAttrs,
                onSortChange: _ctx.onSortChange,

                onHeaderDragend: _ctx.headerDragendFn,
                cellClassName: _ctx.cellClassNameFn,

                height: tableAttrs.height
                  ? tableAttrs.height
                  : _ctx.$props.fullPageList
                  ? _ctx.compoundData.listHeight
                  : undefined,
              }}
              style={
                tableAttrs.style ? (tableAttrs.style as CSSProperties) : {}
              }
              v-loading={loadDataState.loading}
              data={
                isArray(loadDataState.listData) ? loadDataState.listData : []
              }
              ref={(el: any) => setRef(el, "elTableRef")}
            >
              {selectRow && !_ctx.$props.useVirtual ? (
                <ElTableColumn
                  width={35}
                  label=""
                  fixed={true}
                  reserveSelection={_ctx.$props.reserveSelection}
                  type="selection"
                />
              ) : null}
              {selectRow &&
              _ctx.$props.useVirtual &&
              _ctx.$props.useVirtualSelect
                ? h(
                    ElTableColumn,
                    {
                      className: "use-virtual-select",
                      width: 35,
                      label: "",
                    },
                    useVirtualScopedSlots
                  )
                : null}
              {_ctx.$props.showVirtualIndex && _ctx.$props.useVirtual
                ? h(
                    ElTableColumn,
                    {
                      width: 50,
                      className: "use-virtual-indexes",
                      label: "序号",
                      type: "text",
                      align: "center",
                    },
                    {
                      default: (data: any) => {
                        return [
                          <span>
                            {_ctx.compoundData.showStartIdx + data.$index + 1}
                          </span>,
                        ];
                      },
                    }
                  )
                : null}
              {showIdxCol
                ? h(
                    ElTableColumn,
                    {
                      width: 60,
                      label: "序号",
                    },
                    { default: idxScopedSlots }
                  )
                : null}
              {_ctx.headerRender(_ctx.showHeaders)}
            </ElTable>
          )}
        </div>
        <div
          ref={(el: any) => setRef(el, "pageWrap")}
          class="el-pagination-wrap"
        >
          {!!loadDataState.total && pagination
            ? h(ElPagination, { ...pageOn, ...setPageProps })
            : null}
        </div>
      </div>
    );
  },
});
</script>
<style lang="scss" scoped>
:deep( .table-scope-checked ) {
  background-color: #2a364f !important;
  color: #fff;
}
:deep( .el-table ) {
  thead {
    color: inherit;
  }
  .caret-wrapper {
    width: 1px;
  }
}
:deep( .virtual-table ) {
  .el-table__body-wrapper .el-scrollbar__bar {
    z-index: 1000;
  }
  .use-virtual-select {
    position: relative;
    z-index: 500;
    background-color: #fff;
    transition: opacity 0.2s;
    box-shadow: 10px 0px 5px 0 rgba(0, 0, 0, 0.05);
  }
  .use-virtual-indexes {
    position: relative;
    z-index: 500;
    background-color: #fff;
    transition: opacity 0.2s;
    box-shadow: 10px 0px 5px 0 rgba(0, 0, 0, 0.05);
  }
  .use-virtual-options {
    position: relative;
    z-index: 500;
    background-color: #fff;
    transition: opacity 0.2s;
    box-shadow: -10px 0px 5px 0 rgba(0, 0, 0, 0.05);
  }
  .use-virtual-right-addition1 {
    position: relative;
    z-index: 500;
    background-color: #fff;
    transition: opacity 0.2s;
    box-shadow: -10px 0px 5px 0 rgba(0, 0, 0, 0.05);
  }
  .use-virtual-right-addition2 {
    position: relative;
    z-index: 500;
    background-color: #fff;
    transition: opacity 0.2s;
    box-shadow: -10px 0px 5px 0 rgba(0, 0, 0, 0.05);
  }
}
</style>
